import { Screens } from "./screen_manager.js";

export abstract class Screen
{
  abstract nameUI(): Screens;

  abstract init( params?: any ): Promise<void>;
  /** Called once the initialized screen has produced its first visible frame. */
  afterFirstPaint?(): void | Promise<void>;
  /** Runs while the loading canvas still covers the ready screen; it stays up until this resolves. */
  beforeLoadingHidden?( wait_for_play: () => Promise<boolean> ): Promise<void>;
  /** Continues startup work that was deferred behind a level-intro overlay. */
  afterIntroOverlay?(): void | Promise<void>;
  abstract update( dt: number ): void;
  abstract destroy(): void;
}